function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".vehicle{fill:#fff;}\n"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "vehicle",
  d: "M18.736,36.167l-.287-4.261a1.2,1.2,0,0,0-1.2-1.1H5.525a1.2,1.2,0,0,0-1.2,1.1l-.279,4.261ZM21.2,40.539a1.584,1.584,0,1,0-1.58,1.58,1.584,1.584,0,0,0,1.58-1.58m-4.621,2.373V38.919a.721.721,0,0,0-.72-.72H6.88a.719.719,0,0,0-.709.72v3.993ZM3.148,42.118a1.583,1.583,0,1,0-1.583-1.58,1.58,1.58,0,0,0,1.583,1.58m14.1-12.428a2.326,2.326,0,0,1,2.311,2.131l.294,4.39,2.92,1.766-.007,7.417h-1.3l.007,2.425a1.89,1.89,0,0,1-3.78,0V45.395H5.081l.007,2.425a1.89,1.89,0,0,1-3.781,0V45.395H.007L0,37.978l2.92-1.766.294-4.39A2.316,2.316,0,0,1,5.525,29.69Z",
  transform: "translate(0 -29.69)"
});

var SvgVehicle = function SvgVehicle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.773,
    height: 20.018,
    viewBox: "0 0 22.773 20.018",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVehicle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vehicle.b83b6a74.svg";
export { ForwardRef as ReactComponent };